export default {"src":"/_next/static/media/Settings.065f89ab.svg","height":80,"width":80,"blurWidth":0,"blurHeight":0};